import React from 'react';

const DailyRoutinePage = () => {
  return (
    <div className=" mx-auto py-12 px-4 bg-gray-100 font-sans">
        
      <h1 className="text-4xl font-bold text-center mb-12 uppercase text-[#4a6b2e]">Daily Routine</h1>

      {/* Articles Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        
        {/* Article 1 */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img src="https://www.fitsri.com/wp-content/uploads/2023/05/meditation-for-vata-pitta-and-kapha-1024x683.jpg" alt="Pitta balancing" className="w-full h-56 object-cover" />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Daily Routine</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Pitta Balancing Daily Routine</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Adopting a daily routine is a very purposeful and enduring act of self-love. Each day, our routines provide us with a tangible opportunity to prioritize our own health and wellbeing.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 2 */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img src="https://i.ytimg.com/vi/g4vSOOQroYs/maxresdefault.jpg" alt="Kapha balancing" className="w-full h-56 object-cover" />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Daily Routine</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Kapha Balancing Daily Routine</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Discover the ideal routine to balance Kapha dosha, focusing on an invigorating start to your day to maintain energy and clarity throughout.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>

        {/* Article 3 */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img src="https://www.fitsri.com/wp-content/uploads/2023/06/Pranayama-for-vata-pitta-and-kapha-dosha-1024x683.png" alt="Vata-Pitta balancing" className="w-full h-56 object-cover" />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Daily Routine</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Vata-Pitta and Pitta-Vata Balancing Routine</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Learn how to create a harmonious daily schedule that addresses the unique needs of a combined Vata-Pitta constitution for optimal health.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>
        
        {/* Article 4 */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img src="https://i.ytimg.com/vi/eA366xSlzuE/maxresdefault.jpg" alt="Meditation" className="w-full h-56 object-cover" />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Daily Routine</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Introduction to Daily Routine</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              The tradition of dinacharya (daily routine) is one of the single most powerful Ayurvedic tools for improving overall health and wellbeing.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>
        
        {/* Article 5 */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img src="https://thriveeffortlessly.com/wp-content/uploads/2024/02/Ayurvedic-Self-Massage-for-Rejuvenation-1024x585.png" alt="Woman holding apple" className="w-full h-56 object-cover" />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Daily Routine</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">Ayurvedic Self-Massage</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              Abhyanga is the anointing of the body with oil. Often infused with herbs and usually warm, the oil is massaged into the entire body as part of a daily routine.
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>
        
        {/* Article 6 */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <img src="https://goldenbuddhayoga.com/wp-content/uploads/2025/06/chair-yoga-poses-pdf-hero.webp" alt="Smiling woman" className="w-full h-56 object-cover" />
          <div className="p-6">
            <p className="text-xs uppercase text-gray-500 mb-2 font-bold">Ayurveda / Daily Routine</p>
            <h3 className="text-xl font-bold text-[#4a6b2e] mb-3">How to Choose the Perfect Herbal Massage Oil</h3>
            <p className="text-sm text-gray-700 mb-4 leading-relaxed">
              The use of herbal oil is an essential foundation of an Ayurvedic lifestyle. Even beyond the many physical benefits, the simple act of applying oil to the body can be...
            </p>
            <a href="#" className="text-[#008000] uppercase text-sm font-bold hover:underline">Read Article</a>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default DailyRoutinePage;